import EditInterviewModal from './EditInterviewModal';
export default EditInterviewModal;